import { Navbar } from "components/ui/Navbar/Navbar"
import { PageAllFiles } from "components/pages/PageAllFiles/PageAllFiles"
import { PageAuth } from "components/pages/PageAuth/PageAuth"
import { PageConfiguration } from "components/pages/PageConfiguration/PageConfiguration"
import { PageTeam } from "components/pages/PageTeam/PageTeam"
import { PageAbout } from "components/pages/PageAbout/PageAbout"
import { PageRegistration } from "components/pages/PageRegistration/PageRegistration"
import { PageForgotPassword } from "components/pages/PageForgotPassword/PageForgotPassword"
import { Route, Navigate } from "react-router-dom"
import { PageRegistrationActivation } from "components/pages/PageRegistrationActivation/PageRegistrationActivation"
import { SentryRoutes } from "./sentry"
import { PageResetPassword } from "components/pages/PageResetPassword/PageResetPassword"
import { Keywords } from "components/pages/PageConfiguration/layout/Keywords/Keywords"
import { ObjectsCategories } from "components/pages/PageConfiguration/layout/ObjectsCategories/ObjectsCategories"
import { DimensionsTolerance } from "components/pages/PageConfiguration/layout/DimensionsTolerance/DimensionsTolerance"
import { CompetitorsModelNumbers } from "components/pages/PageConfiguration/layout/CompetitorsModelNumbers/CompetitorsModelNumbers"
import { AIInstructions } from "components/pages/PageConfiguration/layout/AIInsructions/AIInstructions"
import { ModelNumbers } from "components/pages/PageConfiguration/layout/ModelNumbers/ModelNumbers"

const isQuotationLocked = import.meta.env.VITE_LOCK_QUOTATION_FEATURE === "true"
const defaultConfigRoute = isQuotationLocked ? "/configuration/keywords" : "/configuration/model-numbers"

export const useRoutes = (isAuthenticated: boolean) => {
	if (isAuthenticated) {
		return (
			<main className="page">
				<Navbar />
				<SentryRoutes>
					<Route path="/all-files" element={<PageAllFiles />} />
					<Route path="/configuration" element={<PageConfiguration />}>
						<Route index element={<Navigate to={defaultConfigRoute} replace />} />
						<Route path="keywords" element={<Keywords />} />
						<Route path="objects" element={<ObjectsCategories />} />
						<Route path="dimensions-tolerance" element={<DimensionsTolerance />} />
						<Route path="competitors-model-numbers" element={<CompetitorsModelNumbers />} />
						<Route path="ai-instructions" element={<AIInstructions />} />
						{!isQuotationLocked && <Route path="model-numbers" element={<ModelNumbers />} />}
					</Route>
					<Route path="/team" element={<PageTeam />} />
					<Route path="/about" element={<PageAbout />} />
					<Route path="*" element={<Navigate to="/all-files" replace />} />
				</SentryRoutes>
			</main>
		)
	}

	return (
		<SentryRoutes>
			<Route path="/" element={<PageAuth />} />
			<Route path="/signup" element={<PageRegistration />} />
			<Route path="/registration-activation" element={<PageRegistrationActivation />} />
			<Route path="/forgot-password" element={<PageForgotPassword />} />
			<Route path="/password-reset-confirm" element={<PageResetPassword />} />
			<Route path="*" element={<Navigate to="/" replace />} />
		</SentryRoutes>
	)
}
